export default __webpack_public_path__ + "static/media/breathin.d9975338.png";